import React from 'react';
import './style.css';

const ButtonStyle = ({ children, ...rest }) => (
  <button {...rest}>
    {children}
  </button>
);

export default ButtonStyle;
